// useRLContext — SS-8/CP-1.3 (Jun 2026).
//
// Fetches `GET /api/admin/racket-lab/me-context` ONCE per page load and
// caches it module-wide so the RBAC sidebar, section guards and scoped
// pages share a single resolution of "who am I inside Racket Lab".
//
// On any error (e.g. 403 for non-shell roles) it degrades to an empty
// sections list so guards fail CLOSED, never open.

import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let _cache = null;
let _promise = null;

export const clearRLContextCache = () => {
  _cache = null;
  _promise = null;
};

export default function useRLContext() {
  const [state, setState] = useState({ ctx: _cache, loading: !_cache });

  useEffect(() => {
    if (_cache) return undefined;
    if (!_promise) {
      _promise = api
        .get("/admin/racket-lab/me-context")
        .then((r) => {
          _cache = r.data;
          return _cache;
        })
        .catch(() => {
          _cache = { profile: null, sections: [], error: true };
          return _cache;
        });
    }
    let alive = true;
    _promise.then((ctx) => {
      if (alive) setState({ ctx, loading: false });
    });
    return () => {
      alive = false;
    };
  }, []);

  return state;
}
